import React, { useEffect, useState, useContext } from 'react';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import UserContext from '../../contexts/UserContext';
import Api from '../../services/Api';
import ListItemEventFinance from '../../components/ListItemEventFinance';
import Functions from '../../services/Functions';
import './styles.css';
import '../../App.css';
import { customStylesModal } from '../../util/constants';

export default function DashboardEventsFinance({ setLoading }) {
    const { user } = useContext(UserContext);
    const isAdmin = user[0].user.admin;
    const isAdminShop = user[0].user.adminShop;
    const isColaborador = user[0].user?.role === "COLABORADOR";
    const [eventFinances, setEventFinances] = useState([]);
    const [shops, setShops] = useState([]);
    const [selectedShop, setSelectedShop] = useState(user[0].user.adminShop ? user[0].user.shop._id : "all");
    const [dateRange, setDateRange] = useState([new Date(new Date().setDate(new Date().getDate() - (isColaborador ? 1 : 30))), new Date()]);
    const [selectedPackage, setSelectedPackage] = useState("all");

    const [startDate, endDate] = dateRange;

    // Função para calcular os totalizadores
    const getTotals = () => {
        let totalEventsAmount = 0;
        let totalExpensesAmount = 0;

        eventFinances.forEach(register => {
            totalEventsAmount += Number(register.totalAmount || 0);

            register.expenses?.forEach(exp => {
                totalExpensesAmount += Number(exp.value || 0);
            });
        });
        return { totalEventsAmount, totalExpensesAmount };
    };

    const { totalEventsAmount, totalExpensesAmount } = getTotals();

    useEffect(() => {
        if (isAdmin) {
            loadAllShops();
        } else {
            setSelectedShop(user[0].user.shop._id);
        }
    }, []);

    useEffect(() => {
        if (endDate && selectedShop) {
            loadEventFinance();
        }
    }, [endDate, selectedShop, selectedPackage]);

    async function loadEventFinance() {
        try {
            setLoading(true);
            const start = startDate ? startDate.toISOString().substr(0, 10) : 'all';
            const end = endDate ? endDate.toISOString().substr(0, 10) : 'all';
            const response = await Api.getItems(`/get-event-finance/${selectedShop}/${start}/${end}/${selectedPackage}`);
            setEventFinances(response);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    async function loadAllShops() {
        try {
            setLoading(true);
            const response = await Api.getShops();
            setShops(response);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    async function addEventFinance() {
        const copy = Array.from(eventFinances);
        copy.unshift({
            _id: copy.length + 1, // temporary ID
            date: "",
            clientName: "",
            city: "",
            packageOption: "",
            guestsCount: 0,
            totalAmount: 0,
            expenses: [
                { name: "Garçons", value: 0 },
                { name: "Pizzaiolo", value: 0 },
                { name: "Combustível", value: 0 }
            ],
            shop: user[0]?.user?.shop,
            user: user[0]?.user,
        });
        setEventFinances(copy);
        setTimeout(() => {
            document.getElementsByClassName("headList")[0]?.click();
        }, 100);
    }

    return (
        <div id="leadList" className="bodyDashboard">
            <div className="v-center" style={{ marginBottom: 10 }}>
                {isAdmin &&
                    <div className="col-12 col-md-12">
                        <select className="title" value={selectedShop} style={{ border: 0, background: 'transparent', cursor: 'pointer', marginBottom: 8 }} onChange={event => setSelectedShop(event.target.value)}>
                            <option value="all">Todas Unidades</option>
                            {shops.map((item) => (
                                <option key={item._id} value={item._id}>{item.name}</option>
                            ))}
                        </select>
                    </div>
                }
                <div className="col-12 col-md-4">
                    <select className="title" value={selectedPackage} style={{ border: 0, background: 'transparent', cursor: 'pointer' }} onChange={event => setSelectedPackage(event.target.value)}>
                        <option value="all">Todos os Pacotes</option>
                        <option value="Pacote Econômico">Pacote Econômico</option>
                        <option value="Pacote Parmas">Pacote Parmas</option>
                        <option value="Pacote Parmas Premium">Pacote Parmas Premium</option>
                    </select>
                </div>
                <div className="col-12 col-md-6 text-center">
                    <DatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={(update) => setDateRange(update)}
                        disabled={isColaborador}
                        className="titleDate"
                        dateFormat={'dd/MM/yyyy'}
                        withPortal
                    />
                </div>
                <div className="col-12 col-md-2 text-right">
                    {isAdminShop &&
                        <button type="button" onClick={addEventFinance} className="btnNew" title="Novo Evento"><i className="fa fa-plus fa-lg"></i></button>
                    }
                </div>
            </div>

            <div className="col-12">
                {eventFinances.length > 0 && !isColaborador &&
                    <div className="totalsBoard" style={{ marginBottom: 20 }}>
                        <div className="totalsRow">
                            <div className="totalsItem">Total Faturado: <strong>R$ {Functions.formatMoney(totalEventsAmount)}</strong></div>
                            <div className="totalsItem">Total Despesas: <strong>R$ {Functions.formatMoney(totalExpensesAmount)}</strong></div>
                            <div className="totalsItem">Lucro Líquido: <strong>R$ {Functions.formatMoney(totalEventsAmount - totalExpensesAmount)}</strong></div>
                        </div>
                    </div>
                }

                <ul className="dashboardList">
                    {eventFinances.length > 0 ?
                        eventFinances.map(item => (
                            <ListItemEventFinance
                                key={item._id}
                                id={item._id}
                                date={item.date}
                                clientName={item.clientName}
                                city={item.city}
                                packageOption={item.packageOption}
                                guestsCount={item.guestsCount}
                                totalAmount={item.totalAmount}
                                expenses={item.expenses}
                                shop={item.shop}
                                user={item.user}
                                createdAt={item.createdAt}
                                updatedAt={item.updatedAt}
                                loadEventFinance={loadEventFinance}
                                setLoading={setLoading}
                                isColaborador={isColaborador}
                            />
                        )) :
                        <div className="col-12 text-center" style={{ marginTop: 50 }}>
                            <span className="labelFilter">Nenhum evento encontrado!</span>
                        </div>}
                </ul>
            </div>
        </div>
    );
}
